import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Breadcrumbs from '../components/common/Breadcrumbs';
import OrgBlock from '../components/common/OrgBlock';
import SectionHeader from '../components/common/SectionHeader';
import NewsCard from '../components/common/NewsCard';

const PersonaDettaglioPage = () => {
  return (
    <Layout>
      <div className="container"><Breadcrumbs items={[{ label: 'Home', path: '/' }, { label: 'Persone', path: '/persone' }, { label: 'Marco Ferrara' }]} style={{ paddingTop: 'var(--space-6)' }} /></div>
      <section className="section section--sm"><div className="container"><div className="detail-layout">
        <div className="content-narrow">
          <div style={{ display: 'flex', gap: 'var(--space-8)', alignItems: 'flex-start', flexWrap: 'wrap', marginBottom: 'var(--space-10)' }}>
            <div style={{ width: 160, height: 160, borderRadius: 'var(--radius-full)', overflow: 'hidden', flexShrink: 0 }}>
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=400&auto=format&fit=crop" alt="Marco Ferrara" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div style={{ flex: 1, minWidth: 250 }}>
              <h1 className="h1 mb-1">Marco Ferrara</h1>
              <div className="h4 text-primary mb-2">Segretario Nazionale</div>
              <p className="text-body-sm text-secondary" style={{ maxWidth: 500 }}>28 anni, romano. Laureato in Scienze Politiche alla Sapienza. Segretario Nazionale dei Giovani Democratici dal 2024.</p>
            </div>
          </div>
          <div className="prose">
            <h2>Biografia</h2>
            <p>Marco Ferrara nasce a Roma nel 1998. Si avvicina alla politica durante gli anni del liceo, entrando nei Giovani Democratici a 18 anni. Laureato in Scienze Politiche alla Sapienza, è stato segretario del circolo GD Trastevere, poi segretario di federazione Roma, e infine eletto Segretario Nazionale al Congresso del 2024.</p>
            <p>Il suo impegno si concentra su tre temi principali: lavoro giovanile, diritto all'abitare e transizione ecologica. Ha guidato campagne nazionali come "Abitare Giovane" e "Scuola Libera".</p>
            <blockquote>"Il compito della nostra generazione è dimostrare che la politica è lo strumento più potente per cambiare la realtà."</blockquote>
          </div>
          <div className="mt-10"><SectionHeader overline="Deleghe" title="Responsabilità" />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)', marginTop: 'var(--space-4)' }}>
              {['Coordinamento generale', 'Rapporti istituzionali', 'Campagne nazionali', 'Rappresentanza esterna'].map((d) => (
                <div key={d} style={{ padding: 'var(--space-3) var(--space-4)', background: 'var(--color-surface)', borderRadius: 'var(--radius-md)', border: '1px solid var(--color-border-subtle)' }}>{d}</div>
              ))}
            </div>
          </div>
          <div className="mt-10"><SectionHeader title="Notizie correlate" />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)', marginTop: 'var(--space-4)' }}>
              <NewsCard variant="compact" title="Forum Nazionale Giovani e Lavoro" meta={['22 Mar 2026']} image="https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=800&auto=format&fit=crop" />
              <NewsCard variant="compact" title="Assemblea Nazionale: il documento approvato" meta={['15 Mar 2026']} image="https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=800&auto=format&fit=crop" />
            </div>
          </div>
        </div>
        <aside>
          <OrgBlock title="Ruolo" className="mb-6">
            <div style={{ marginTop: 'var(--space-4)', display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
              {[{ label: 'Incarico', value: 'Segretario Nazionale' }, { label: 'Dal', value: 'Marzo 2024' }, { label: 'Territorio', value: 'Nazionale' }, { label: 'Età', value: '28 anni' }].map((i) => (
                <div key={i.label}><div className="text-label">{i.label}</div><div className="text-body-sm" style={{ fontWeight: 600 }}>{i.value}</div></div>
              ))}
            </div>
          </OrgBlock>
          <OrgBlock title="Contatti">
            <div style={{ marginTop: 'var(--space-4)', display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
              <a href="#" className="link text-body-sm">segretario@giovanidemocratici.it</a>
              <div className="flex gap-2 mt-2"><a href="#" className="share-actions__btn">ig</a><a href="#" className="share-actions__btn">x</a><a href="#" className="share-actions__btn">f</a></div>
            </div>
          </OrgBlock>
        </aside>
      </div></div></section>
    </Layout>
  );
};

export default PersonaDettaglioPage;
